import Vue from 'vue/dist/vue.esm.js';

Vue.component('blog', {
    template: `#blog`,
    delimiters: ['[[', ']]'],
    props: {
        categoriesJson: {
            type: Array,  // Add an explicit type for this prop if needed
            required: false, // Optional, depending on whether it's required
            default: () => [],
        },
        showTitle: {
            type: String,
            default: false,
        },
        showLoadMore: {
            type: Boolean,
            default: true,
        },
        maxResults: {
            type: Number,  // Define 'maxResults' as a Number
            default: 12,   // Set default value to 12
        },
        initialBlogs: {
            type: Array,
            default: () => [],
        },
        hideCarousel: {
            type: Boolean,
            default: false,
        },
    },
    data () {
        return {
            selectedCategories: [0],
            categories: this.categoriesJson,
            blogs: this.initialBlogs || [],
            more: false,
            nextPage: 1,
            expandedItems: []
        }
    },
    mounted() {
        // Only fetch blogs if initialBlogs is not provided
        if (!this.initialBlogs || this.initialBlogs.length === 0) {
            this.fetchBlogs();
        }
    },
    computed: {
        filteredBlogs() {
            // If initialBlogs are provided, return them directly without filtering
            if (this.initialBlogs && this.initialBlogs.length > 0) {
                return this.blogs;
            }
            return this.blogs && this.blogs.length > 0 && this.blogs.filter(item => {
                return this.selectedCategories.includes(0) ||
                    this.selectedCategories.includes(item.category.id);
            })
        },
    },
    methods: {
        handleInput() {
            this.more = false;
            if(this.searchQuery.length > 3)
            {
                this.blogs = [];
                this.nextPage = 1;
                this.fetchBlogs(1);
            }
        },
        fetchBlogs(pageNumber = 1) {
            this.more = false;

            let _self = this;
            const categories = this.selectedCategories.includes(0)
                ? [0]
                : this.selectedCategories;

            const url = "/ajax/blogs?" + $.param({
                categoryIds: categories,
                page: pageNumber,
                limit: this.maxResults,
                searchQuery: this.searchQuery,
            });

            $.ajax({
                url: url,
                method: 'POST',
                processData: false,
                contentType: false,
                success: (response) => {
                    if (response.results) {
                        this.blogs = pageNumber === 1
                            ? response.results
                            : [...this.blogs, ...response.results];

                        _self.more = response.more;
                        _self.nextPage = response.nextPage;
                    }
                },
                error: (error) => {
                    console.log(error);
                }
            });
        },
        handleSelect(categoryId) {
            if (categoryId === 0) {
                this.selectedCategories = [0];
            } else {
                const index = this.selectedCategories.indexOf(categoryId);
                if (index === -1) {
                    this.selectedCategories = this.selectedCategories.filter(id => id !== 0);
                    this.selectedCategories = [];
                    this.selectedCategories.push(categoryId);
                } else {
                    this.selectedCategories.splice(index, 1);
                    if (this.selectedCategories.length === 0) {
                        this.selectedCategories = [0];
                    }
                }
            }
            this.fetchBlogs(1);
        },
        isSelected(categoryId) {
            return this.selectedCategories.includes(categoryId);
        },
        loadMore() {
            if (this.more) {
                this.fetchBlogs(this.nextPage);
            }
        },
        toggleItem(itemId) {
            const index = this.expandedItems.indexOf(itemId)
            if (index === -1) {
                this.expandedItems.push(itemId)
            } else {
                this.expandedItems.splice(index, 1)
            }
        },
    }
});
